import { render, staticRenderFns } from "./GridDash.vue?vue&type=template&id=b80be550&scoped=true"
import script from "./GridDash.vue?vue&type=script&lang=js"
export * from "./GridDash.vue?vue&type=script&lang=js"
import style0 from "./GridDash.vue?vue&type=style&index=0&id=b80be550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80be550",
  null
  
)

export default component.exports